module.exports = __webpack_public_path__ + "img/bg_math_02.f7758fc0.jpg";